// Chemin vertical à sept étapes d'une demande (écran S21) : étapes faites, étape en cours mise en
// avant, étapes à venir expliquées ; barre des sept étapes pour l'encart d'état.
import { Check } from 'lucide-react';
import { cheminDossier, rangStatut } from '../statuts';
import type { FicheDossierUsager } from '../types';
import styles from './suivi.module.css';

export function BarresEtapes({ statut }: { statut: string }) {
  const courant = rangStatut(statut);
  return (
    <div className={styles.barres} aria-hidden>
      {Array.from({ length: 7 }, (_, i) => (
        <span key={i} data-etat={i + 1 < courant ? 'faite' : i + 1 === courant ? 'courante' : 'a_venir'} />
      ))}
    </div>
  );
}

export function CheminDossier({ dossier }: { dossier: Pick<FicheDossierUsager, 'statut' | 'historique' | 'resultat' | 'echeance_reglementaire' | 'complement' | 'documents_delivres'> }) {
  const etapes = cheminDossier(dossier);
  return (
    <ol className={styles.chemin} aria-label="Le chemin de votre demande">
      {etapes.map((e) => (
        <li key={e.rang} className={styles.etape} data-etat={e.etat} aria-current={e.etat === 'courante' ? 'step' : undefined}>
          <span className={styles.rail}>
            <span className={styles.cercle}>{e.etat === 'faite' ? <Check aria-hidden strokeWidth={3.2} width={11} height={11} /> : null}</span>
            <span className={styles.trait} />
          </span>
          <span className={styles.texteEtape}>
            <span className={styles.titreEtape}>
              {e.titre}
              <span className="cc-masque">{e.etat === 'faite' ? ', étape franchie' : e.etat === 'courante' ? ', étape en cours' : ', à venir'}</span>
            </span>
            <span className={styles.detailEtape}>{e.detail}</span>
          </span>
        </li>
      ))}
    </ol>
  );
}
